import { initSwiperSlider, destroySwiperSlider } from '@theme/utilities';
import { Navigation, Pagination } from '@theme/swiper-modules';

class VideoSlider extends HTMLElement {
  connectedCallback() {
    const rawDesktop = this.dataset.slidesDesktop;
    const rawMobile = this.dataset.slidesMobile;
    const desktopSlides = rawDesktop === 'auto' ? 'auto' : (parseInt(rawDesktop, 10) || 4);
    const mobileSlides = rawMobile === 'auto' ? 'auto' : (parseInt(rawMobile, 10) || 1);
    const spaceBetween = parseInt(this.dataset.spaceBetween, 10) || 16;
    const spaceBetweenMobile = parseInt(this.dataset.spaceBetweenMobile, 10) || spaceBetween;
    const offsetBefore = parseInt(this.dataset.offsetBefore, 10) || 0;
    const offsetBeforeMobile = parseInt(this.dataset.offsetBeforeMobile, 10) || 0;
    const showPagination = this.dataset.paginationDesktop === 'true' || this.dataset.paginationMobile === 'true';
    const modules = [Navigation];
    if (showPagination) modules.push(Pagination);
    this._swiper = initSwiperSlider(this, {
      containerSelector: '.video-slider__swiper',
      prevSelector: '.video-slider__prev',
      nextSelector: '.video-slider__next',
      swiperOptions: {
        modules,
        slidesPerView: mobileSlides,
        spaceBetween: spaceBetweenMobile,
        slidesOffsetBefore: offsetBeforeMobile,
        speed: 500,
        ...(showPagination && {
          pagination: {
            el: '.video-slider__pagination',
            clickable: true,
          },
        }),
        breakpoints: {
          768: {
            slidesPerView: desktopSlides,
            spaceBetween,
            slidesOffsetBefore: offsetBefore,
          },
        }
      },
    });
  }

  disconnectedCallback() {
    destroySwiperSlider(this, {
      containerSelector: '.video-slider__swiper',
    });
  }
}

if (!customElements.get('video-slider')) {
  customElements.define('video-slider', VideoSlider);
}
